import type { MultiSelectFieldType } from '@Types/GF/Fields';

import { useEffect } from 'react';

import { ErrorIcon } from '@/views/Shared/Icons';

type Props = {
	field: MultiSelectFieldType;
	setFormValues: React.Dispatch<any>;
	formValues: any;
	errorMessage: string;
};

export default function MultiSelectField({
	field,
	formValues,
	setFormValues,
	errorMessage,
}: Props) {
	const { id, formId, type, label, description, cssClass, isRequired, choices } = field;
	const htmlId = `field_${formId}_${id}`;

	useEffect(() => {
		updateValues(choices[0].value);
	}, []);

	const updateValues = (values: any) => {
		const valuesArr: string[] = [];
		if (values) {
			Array.from(values).forEach((option: any) => {
				valuesArr.push(option.value);
			});
		}
		const cleanedArr = valuesArr.filter(function (element) {
			return element !== undefined;
		});
		const _form = { ...formValues };
		_form.values[`input_${id}`] = cleanedArr;
		setFormValues(_form);
	};

	return (
		<div className={`gfield gfield-${type} ${cssClass}`.trim()}>
			{errorMessage && (
				<p className={`mt-1 inline-flex items-center gap-2 text-base text-minos-form-error-color`}>
					<ErrorIcon />
					{errorMessage}
				</p>
			)}

			<div className={`relative w-full ${description ? 'mb-10' : 'mb-5'}`}>
				<select
					name={String(id)}
					id={htmlId}
					required={Boolean(isRequired)}
					onChange={(e) => updateValues(e.target.selectedOptions)}
					className='peer relative size-full appearance-none rounded-minos-form-input border-2 border-minos-form-input-border-color bg-minos-form-input-bg-color p-4 text-base text-minos-form-input-color outline outline-0 transition-all focus:border-2 focus:border-minos-form-secondary-color focus:outline-0 disabled:cursor-not-allowed disabled:bg-minos-blue_dark-100'
					multiple
				>
					{choices?.map((choice) => (
						<option key={choice?.value || ''} value={choice?.value || ''}>
							{choice?.text || ''}
						</option>
					))}
				</select>

				<label
					htmlFor={htmlId}
					className={`pointer-events-none absolute -top-3.5 left-4 !overflow-visible truncate rounded-md bg-minos-form-input-bg-color px-1.5 py-1 !text-[11px] text-base leading-tight text-minos-form-input-color transition-all peer-focus:rounded-md peer-focus:bg-minos-form-input-bg-color peer-focus:px-1.5 peer-focus:py-1 peer-focus:text-[11px] peer-focus:font-semibold peer-focus:leading-tight peer-focus:text-minos-form-secondary-color peer-disabled:text-transparent ${
						isRequired &&
						'after:ml-0.5 after:font-semibold after:text-minos-form-require-color after:content-["*"] '
					}`}
				>
					{label}
				</label>

				{description ? (
					<p className='minos-form-content-font-style mt-1 text-base tablet:minos-form-content-font-style'>
						{description}
					</p>
				) : null}
			</div>
		</div>
	);
}
